export const iconFontAwesomeEditingGripVertical = (
	<i className="fa-solid fa-grip-vertical"></i>
);
